import { Navigate } from 'react-router-dom'

import { AlertProvider } from '../components/AlertContext'
import { useAuth } from '../components/AuthContext'
import { HeaderProvider } from '../components/HeaderContext'
import { Loader } from '../components/common/loader'

export function RequireAuth({
    children,
    redirectTo = '/login',
    bare = false,
}: any): any {
    const { user, platform } = useAuth()

    if (user === undefined && platform === null) {
        return (
            <>
                <Loader />
            </>
        )
    }

    if (!user && !platform) {
        return <Navigate to={redirectTo} />
    }

    // The redesign renders its own shell + nav, so it opts out of the legacy
    // Header (HeaderProvider) via `bare`.
    if (bare) {
        return <AlertProvider>{children}</AlertProvider>
    }

    return (
        <HeaderProvider>
            <AlertProvider>{children}</AlertProvider>
        </HeaderProvider>
    )
}
